export const GET_AI_VISIBILITY_RUNS = 'GET_AI_VISIBILITY_RUNS';
export const GET_AI_VISIBILITY_REPORTS = 'GET_AI_VISIBILITY_REPORTS';
export const GET_AI_VISIBILITY_USAGE = 'GET_AI_VISIBILITY_USAGE';
